angular.module('impactx.basket').controller('CheckMinOrderContentAmountDialogCtrl',  ['$mdDialog', '$scope', 'data', 'trns', '$redirect', 'SearchFilterStorage', CheckMinOrderContentAmountDialogCtrl]);

function CheckMinOrderContentAmountDialogCtrl($mdDialog, $scope, data, trns, $redirect, SearchFilterStorage)
{
    $scope.data = data;
    $scope.trns = trns;

    this.ok = function ()
    {
        $mdDialog.cancel();
    };

    this.toOrderGroup = function ()
    {
        if (data.orderGroupFacets.length > 0) {
            SearchFilterStorage.setFacetFilter(data.orderGroupFacets);
            $redirect.redirectTo(null, "/search");
            $mdDialog.hide();
        }
    };

}